module.exports = __webpack_public_path__ + "static/media/Daniel_Levi_0509773977_Software Developer_CV_2026.cad58c82.docx";